import { createStyles } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

export const useAppHeaderNotificationStyles = makeStyles(() =>
  createStyles({
    root: {
      marginTop: 2,
      position: 'relative',
      cursor: 'pointer',
    },
    iconHolder: {
      cursor: 'pointer',
      display: 'inline-block',
      fontSize: 30,
      lineHeight: 0.8,
      marginRight: 6,
      marginLeft: 6,
      paddingBottom: 3,
    },
    notificationIcon: {
      width: `40px !important`,
    },
  })
)
